<div class="cart-box" (click)="toggleCart()">
  <svg>
    <use href="assets/svg/icon-sprite.svg#stroke-to-do"></use>
  </svg>
  <span class="badge rounded-pill badge-info">{{ projectListCount }}</span>
</div>
<div class="onhover-show-div notification-dropdown" [class.active]="openCart">
  <p class="f-14 mb-0 dropdown-title">Project's Neo Contact Unassigned</p>
  <ul>
    <li
      *ngFor="let project of projectsList | slice: 0 : 5"
      [ngClass]="'b-l-major'"
      class="border-4"
      (click)="goEditProject(project.id)"
    >
      <p>
        {{ project.attributes.project_name }}

        <span class="font-secondary">
          <i
            class="icon-pencil-alt"
            (click)="goEditProject(project.id)"
            ngbTooltip="{{ 'Edit' | ioxTranslate }}"
          >
          </i
        ></span>
      </p>
    </li>
    <li>
      <a class="f-w-700 font-info" (click)="closeAndNavigate()">Check all</a>
    </li>
    <!-- <li><a class="f-w-700" (click)="closeAndNavigate()">Check all</a></li> -->
  </ul>
</div>
